<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card class="d-flex flex-column">
      <v-card-title class="grid-close">
        <span class="headline"
          >{{ originalItem ? "Editar" : "Nueva" }} categoría</span
        >
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
          v-if="!loading"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="5" md="5">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="category.name"
                    label="Nombre de la categoría"
                    :loading="loading"
                    clearable
                    autofocus
                    rounded
                    filled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="category.description"
                    label="Descripción"
                    :loading="loading"
                    clearable
                    rounded
                    filled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    accept="image/png, image/jpeg"
                    show-size
                    counter
                    :disabled="loading"
                    @change="selectedFile"
                    label="Seleccionar imagen"
                    rounded
                    filled
                  ></v-file-input>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-progress-linear
                    color="progress-bar-color"
                    style="border-radius: 10px"
                    class="mt-3"
                    height="30"
                    :value="progress"
                  >
                   <strong>{{ Math.ceil(progress) }}%</strong>
                </v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
            <v-col style="display:flex; justify-content:center; align-item:center" cols="12" sm="7" md="7">
              <!-- <span>Vista previa</span>
              <hr class="title-hr" /> -->
              <img
                class="mt-5 preview"
                :style="
                  !src
                    ? 'border:1px solid #52525242; min-width: 100%; min-height: 245px; object-fit:cover;filter: grayscale(100%);'
                    : ''
                "
                :src="
                  src || defaultImage
                "
              />
            </v-col>
          </v-row>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="12" md="12">
              <v-row justify="end">
                <v-btn
                  :loading="loading"
                  @click="originalItem ? update() : save()"
                  color="btn-color"
                  >Guardar</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";

export default {
  name: "add-category",
  props: ["originalItem"],
  data() {
    return {
      category: {
        name: "",
        description: "",
      },
      defaultImage : require("@/assets/wink-placeholder.png"),
      snackbarText: "",
      snackbar: false,
      loading: false,
      progress: 0,
      src: "",
    };
  },
  computed: {
    ...mapState(["user", "userDoc", "groupId"]),
  },

  methods: {
    selectedFile(e) {
      this.file = e;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.src = e.target.result;
      };
      reader.readAsDataURL(this.file);
    },
    update() {
      if (this.category.name) {
        this.loading = true;
        let data = {
          name: this.category.name,
          description: this.category.description,
          modifiedAt: new Date(),
          modifiedBy: this.$store.state.user.uid,
        };

        db.collection("categories")
          .doc(this.originalItem[".key"])
          .update(data)
          .then(async (response) => {
            if (this.file) await this.uploadImage(this.originalItem[".key"]);
            this.loading = false;
            this.$emit("success");
          })
          .catch((error) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtalo nuevamente.";
            this.snackbar = true;
          });
      } else {
        this.snackbarText = "Debe ingresar el nombre de la categoria.";
        this.snackbar = true;
      }
    },
    save() {
      if (this.category.name) {
        this.loading = true;
        let data = {
          name: this.category.name,
          createdAt: new Date(),
          createdBy: this.$store.state.user.uid,
          description: this.category.description,
          groupId: this.groupId,
        };

        db.collection("categories")
          .add(data)
          .then(async (ref) => {
            if (this.file) await this.uploadImage(ref.id);
            this.loading = false;
            this.$emit("success");
          })
          .catch((error) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtalo nuevamente.";
            this.snackbar = true;
          });
      } else {
        this.snackbarText = "Debe ingresar el nombre de la cartegoria.";
        this.snackbar = true;
      }
    },
    uploadImage(docId) {
      return new Promise((resolve, reject) => {
        let extension = this.file.type.split("/").pop();
        let dataName = `${Math.round(
          Math.random() * (10000000000000 - 100000000) + 100000000
        )}_${Math.round(
          Math.random() * (10000000000000 - 100000000) + 100000000
        )}.${extension}`;

        var uploadTask = fb
          .app()
          .storage("gs://beanage-images")
          .ref()
          .child(`categories/${this.groupId}/${docId}/${dataName}`)
          .put(this.file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            this.progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          (error) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtalo nuevamente.";
            this.snackbar = true;
          },
          function () {
            resolve("success");
            // uploadTask.snapshot.ref.getDownloadURL().then( downloadURL => {
            //     resolve(downloadURL)
            // })
          }
        );
      });
    },
  },
  mounted() {
    if (this.originalItem) {
      this.category = Object.assign({}, this.originalItem);
      this.src = this.category.image ? this.category.image.original : "";
    }
  },
};
</script>

<style scoped>
 .preview {
   max-width: 100%; 
   max-height: 350px;
   object-fit:contain
 }
</style>